<template>
  <div>
    <!--<div class='alert alert-success' v-if='alterados'>
      <h5>Assembléia Marcada!</h5>
      <div v-if='alterados.count'>
        <span>{{alterados.count}}</span>
        <span v-if='alterados.count === 1'>empréstimo foi alterado para dia</span>
        <span v-else>empréstimos foram alterados para dia</span>
        <span>{{alterados.date | formatDate}}!</span>
      </div>
      <div v-else>Nenhum empréstimo alterado</div>
    </div>-->
    <!--<card class='date-picker' title='Marcar Assembléia'>
      <div class="row">
        <div class='form-group col-md-3'>
          <date-picker width='100%' v-model='assembleiaDate' :first-day-of-week='1' lang='pt-br' format='DD-MM-YYYY'></date-picker>
        </div>
        <div class="col-md-3">
          <button class='btn btn-success btn-block' @click='marcarAssembleia()'>Salvar</button>
        </div>
      </div>
    </card>-->
    <card title='Configurações de Membros'>
      <div class='content'>
        <form @submit.prevent.stop='search()'>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Buscar</label>
                <input type="text" name='search' v-model="searchValue" class="form-control border-input" placeholder="Nome">
              </div>
            </div>
          </div>
        </form>
      </div>
    </card>
    <div class="row">
      <div v-for='(item,index) in membros' :key='`item-${index}`' class="col-lg-4 col-md-6 col-12">
        <edit-membro :membro='item'></edit-membro>
      </div>
      <div class="col-md-12 col-12">
        <pagination :count='count' :limit='limit' :page='page' @changePage='changePage($event)'></pagination>
      </div>
    </div>
  </div>
</template>
<script>
import MembrosService from '../services/membros-service'
import OverlayService from '../services/overlay-service'
import { Pagination } from '@/components'
import DatePicker from 'vue2-datepicker'
import EditMembro from '../components/EditMembro.vue'
import EmprestimoService from '../services/emprestimo-service'

export default {
  components: {
    Pagination,
    EditMembro,
    DatePicker
  },

  data () {
    return {
      membros: [],
      count: 0,
      limit: 9,
      page: 0,
      searchValue: '',
      assembleiaDate: '',
      alterados: undefined
    }
  },

  mounted () {
    this.loadMembros()
  },

  methods: {

    marcarAssembleia () {
      OverlayService.trigger('show', true)

      EmprestimoService.marcarAssembleia(this.assembleiaDate)
        .then(response => response.data)
        .then(result => {
          OverlayService.trigger('show', false)

          this.alterados = {
            count: result.length,
            date: result.length ? result[0].data_limite : undefined
          }
        }).catch(er => {
          OverlayService.trigger('show', false)
          this.$alertify.error('Erro ao marcar assembleia')
        })
    },

    loadMembros () {
      const filter = {
        limit: this.limit,
        page: this.page + 1,
        orderBy: [{ orderBy: 'nome', direction: 'asc' }]
      }

      OverlayService.trigger('show', true)

      MembrosService.getAll(filter, this.searchValue)
        .then(response => response.data)
        .then(membros => {
          this.membros = membros.data
          this.count = membros.total

          OverlayService.trigger('show', false)
        })
        .catch(er => {
          OverlayService.trigger('show', false)
          this.$alertify.error('Erro ao recuperar membros')
        })
    },

    getOffset () {
      return this.limit * this.page
    },

    changePage (page) {
      this.page = page
      this.loadMembros()
    },

    search () {
      this.page = 0
      this.loadMembros()
    }
  }
}
</script>
<style>
  .card.date-picker {
    z-index: 4;
  }
</style>
